<template>
  <div class="container-categories">
    <div v-for="category in categories" :key="category.id" class="category-box">
      <div
        :aria-pressed="category.id === selectedCategoryId"
        class="select-category"
        :class="[category.id === selectedCategoryId ? 'selected' : '']"
        role="button"
        tabindex="0"
        @click="() => $emit('onSelectCategory', category.id)"
        @keydown.enter="() => $emit('onSelectCategory', category.id)"
        @keydown.space="() => $emit('onSelectCategory', category.id)"
      >
        <div class="category-title">{{ category.name }}</div>
        <div
          class="numbers-selected"
          :class="[numberOfSelectedTypes(category) !== 0 ? 'more-numbers' : '']"
        >
          <span v-if="numberOfSelectedTypes(category) !== 0">{{
            numberOfSelectedTypes(category)
          }}</span>
          <span v-if="numberOfSelectedTypes(category) !== 0"> / </span>
          <span> {{ category.types.length }} </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { CategoryItem } from '@/components/general/lists/ListMenuWithCheckbox/ListMenuWithCheckbox.vue'

interface EMITS {
  (e: 'onSelectCategory', id: string)
}
defineEmits<EMITS>()

interface PROPS {
  categories: CategoryItem[]
  selectedCategoryId: string
}
defineProps<PROPS>()

function numberOfSelectedTypes(category: CategoryItem) {
  return category.types.filter((type) => type.visible == true).length
}
</script>

<style lang="scss" scoped>
@use '@/design-system/design-tokens/mixins.scss';
@use '@/styles/variables.scss';
.container-categories {
  height: 200px;
  overflow-y: auto;
  white-space: pre-line;
  @include mixins.scrollbar-vertical;
}
.category-box {
  padding-right: 10px;
}
.category-title {
  font-family: Raleway;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0.4000000059604645px;
  text-align: left;
  word-break: break-all;
  padding: 8px;
}
.select-category {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: left;
  font-weight: 600;
  height: 100%;
  color: #000000;
  padding-left: 8px;
  padding-right: 8px;
  border-radius: 4px;
}
.numbers-selected {
  display: flex;
  justify-content: center;
  border-radius: 8px;
  color: black;
  font-family: Inter, sans-serif;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.4px;
  line-height: 16px;
}
.selected {
  width: 100%;
  height: 100%;
  background: #e3e3e3;
  border-radius: 4px;
}
.more-numbers {
  color: white;
  padding: 2px 6px;
  width: 37px;
  height: 20px;
  background-color: variables.$color-grey-darker;
}
@media screen and (max-width: 1024px) {
  .container-categories {
    height: 45vh;
    width: 100%;
    max-width: 642px;
    padding: 0;
    display: flex;
    flex-direction: column;
    row-gap: 16px;
    overflow: unset;
  }

  .category-title {
    padding: 0;
    font-size: 16px;
    font-weight: 600;
  }
  .category-box {
    border-radius: 4px;
  }

  .numbers-selected {
    font-size: 14px;
  }
  .selected {
    border-radius: 0;
  }
  .select-category {
    background-color: white;
    height: 48px;
    margin: 0;
    padding: 16px;
    border-radius: 4px;
  }
}
</style>
